import React from 'react';

import { buildColumn, EditableColumnConfig } from '~components/table-view';
import WorkerQualifications from '~weekly-planner/components/common/WorkerQualifications';
import WorkerFocusAction from '~weekly-planner/components/WorkerFocusAction';

import AppointmentInfo from './AppointmentInfo';

// Define columns for TableView for missing qualifications
const getMissingQualificationsColumns = (extendedView: boolean) => {
  const columnsList: EditableColumnConfig[] = [
    {
      id: 'appointment',
      header: 'Appointment',
      type: 'date',
      props: {
        meta: {
          renderCustom: (_: boolean, row: any) => {
            if (!row) return null;
            const { start_time, date } = row.original ?? row;
            const client = row.original?.client ?? row.client;
            return React.createElement(AppointmentInfo, {
              date,
              start_time,
              client,
            });
          },
        },
      },
    },
    {
      id: 'worker',
      header: 'Worker',
      type: 'text',
      accessorFn: (row) => row.user?.full_name,
    },
    {
      id: 'missing_qualifications',
      header: 'Missing Qualifications',
      type: 'custom',
      props: {
        meta: {
          renderCustom: (_: boolean, row: any) => {
            if (!row) return null;
            const { qualification_level, user } = row.original ?? row;
            return React.createElement(WorkerQualifications, {
              qualifications: qualification_level.filter((item: string) =>
                user?.qualifications.includes(item) ? null : item,
              ),
              isCondensed: !extendedView,
              isWrapped: !extendedView,
            });
          },
        },
      },
    },
    {
      id: 'actions',
      header: '',
      type: 'custom',
      props: {
        meta: {
          renderCustom: (_: never, row: any) => {
            if (!row) return null;
            const userId = row.user?.id;
            return React.createElement(WorkerFocusAction, { userId });
          },
        },
      },
    },
  ];

  return columnsList.map(buildColumn);
};

export default getMissingQualificationsColumns;
